import Installer from './Installer';

export default Installer;
